<script>
import vSelect from "vue-select"
import "vue-select/dist/vue-select.css"


export default {
  name: "PeoplePicker",
  components: {
    vSelect,
  },
  props: {
    value:        { type: Object, required: true  },
    required:     { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      debug: false,
      key: 0,
      options: [],
      selected: {text: "", value: ""},
      observer: null,
      limit: 10,
      search: "",
    }
  },
  computed: {
    filtered () {
      return this.options.filter(itm => itm.text ? itm.text.toLowerCase().includes(this.search.toLowerCase()) : false)
    },
    activeUsers () {
      return Object.keys(this.value).indexOf("activeUsers") != -1 ? this.value.activeUsers : true
    },
    externalUsers () {
      return this.value.externalUsers !== null ? this.value.externalUsers : false
    },
    inactiveUsers () {
      return Object.keys(this.value).indexOf("inactiveUsers") != -1 ? this.value.inactiveUsers : false
    },
    paginated () {
      return this.filtered.slice(0, this.limit)
    },
    hasNextPage () {
      return this.paginated.length < this.filtered.length
    },
    readOnly () {
      return this.value.readOnly !== null ? this.value.readOnly : false
    },
    clearable () {
      return Object.keys(this.value).indexOf("clearable") > -1 ? this.value.clearable : false
    },
    emptyOpt () {
      return this.value.emptyOpt !== null ? this.value.emptyOpt : false
    },
  },
  watch: {
    value: {
      handler(data) {
        if (this.debug) console.log("PeoplePicker Data:", data)
        this.$emit("input", data)
        if (!data) {
          this.retrievePeople()
        } else {
          this.updateSelected(data.value)
        }
      },
      deep: true,
    },
    selected(sel) {
      this.value.value = sel !== null ? sel.value : ""
    },
  },
  created() {
    this.retrievePeople()
    this.observer = new IntersectionObserver(this.infiniteScroll)
  },
  methods: {
    updateSelected(newVal) {
      if (newVal === null) newVal = ""
      for (let i=0;i<this.options.length;i++) {
        const cur = this.options[i]
        if (cur.value == newVal) {
          this.selected = {
            text: cur.text,
            value: cur.value,
          }
          break
        }
      }
    },
    retrievePeople() {
      // TODO: Use a shared site list in store

      const statusCodes = ["F"]
      if (this.externalUsers) statusCodes.push("X")
      if (this.activeUsers) statusCodes.push("A")
      if (this.inactiveUsers) statusCodes.push("I")
      this.$store.dispatch("armint/retrieveAllPeople", statusCodes).then((data) => {
        const peopleList = [{ value: "", text: this.value.defaultLabel }]

        if (this.emptyOpt) {
          peopleList.push({
            value: "empty",
            text: "Clear Selection",
          })
        }

        this.selected = { value: "", text: this.value.defaultLabel }
        const prefix = this.value.prefix ? this.value.prefix : ""
        for (let i=0;i<data.length;i++) {
          peopleList.push({
            value: data[i].personId,
            text: `${prefix + data[i].nameFirst} ${data[i].nameLast} (${data[i].personId})`,
            //selected: data[i].personId == this.value.value
          })
          if (data[i].personId == this.value.value) {
            this.selected = {
              value: data[i].personId,
              text: `${prefix + data[i].nameFirst} ${data[i].nameLast} (${data[i].personId})`,
            }
          }
        }
        //if (this.allowOther) { siteList.push({ value: 'other',   text: 'Other' }) }
        this.options = peopleList
        this.key++
      })
    },
    onChange(data) {
      this.$emit("change", data)
    },
    async onOpen () {
      if (this.hasNextPage) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observer.disconnect()
      this.$emit("doValidation")
    },
    async infiniteScroll ([{isIntersecting, target}]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.limit += 10
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
  },
}
</script>

<template>
  <v-select
    v-model="selected"
    :id="value.id"
    :key="key"
    label="text"
    :options="paginated"
    :filterable="false"
    :disabled="readOnly"
    :externalUsers="externalUsers"
    @change="onChange"
    @open="onOpen"
    @close="onClose"
    @search="query => search = query"
  >
    <template #list-footer>
      <li v-show="hasNextPage" ref="load" class="loader">
        Loading more options...
      </li>
    </template>
  </v-select>
</template>
